'use es6';

import { combineReducers } from 'redux';
import { routerReducer } from 'DesignData/reducers/Routing';
import notifications from 'ReduxMessenger/reducers/Notifications';
import resources from 'ContentData/reducers/Resources';
import app from 'DesignData/reducers/Application';
import auth from 'DesignData/reducers/Auth';
import cosIndexConnections from 'DesignData/reducers/CosIndexConnections';
import customWidgetBuffers from 'DesignData/reducers/CustomWidgetBuffers';
import customWidgets from 'DesignData/reducers/CustomWidgets';
import fonts from 'DesignData/reducers/Fonts';
import globalGroups from 'DesignData/reducers/GlobalGroups';
import globalWidgets from 'DesignData/reducers/GlobalWidgets';
import structuralWidgets from 'DesignData/reducers/StructuralWidgets';
import revisions from 'DesignData/reducers/Revisions';
import tabs from 'DesignData/reducers/Tabs';
import templateBuffers from 'DesignData/reducers/TemplateBuffers';
import templateRevisions from 'DesignData/reducers/TemplateRevisions';
import unifiedLayouts from 'DesignData/reducers/UnifiedLayouts';
import siteSettings from 'DesignData/reducers/SiteSettings';
import stylesheets from 'DesignData/reducers/Stylesheets';
import javascripts from 'DesignData/reducers/Javascripts';
import blogs from 'DesignData/reducers/Blogs';
import domains from 'DesignData/reducers/Domains';
import layoutEditorOptions from 'DesignData/reducers/LayoutEditorOptions';
import layoutDragDropContext from 'DesignData/reducers/LayoutDragDropContext';
import previewOptions from 'DesignData/reducers/PreviewOptions';
import layoutEditorSession from 'DesignData/reducers/LayoutEditorSession';
import layoutGrouping from 'DesignData/reducers/LayoutGrouping';
import portalCopy from 'DesignData/reducers/PortalCopy';
import finder from 'DesignData/reducers/finder';
import codemirrorOptions from 'DesignData/reducers/codemirror/Options';
import codemirrorSession from 'DesignData/reducers/codemirror/Session';
import layoutRevisions from 'DesignData/reducers/LayoutRevisions';
import customWidgetEditorOptions from 'DesignData/reducers/CustomWidgetEditorOptions';
import sharedDragDropContext from 'DesignData/reducers/SharedDragDropContext';
import customWidgetRevisions from 'DesignData/reducers/CustomWidgetRevisions';
import flash from 'DesignData/reducers/Flash';
import onboarding from 'DesignData/reducers/Onboarding';
import editorErrors from 'DesignData/reducers/EditorErrors';
import hublValidator from 'DesignData/reducers/HublValidator';
import hublDocs from 'DesignData/reducers/HublDocs';
import salesforceIntegrationStatus from 'DesignData/reducers/SalesforceIntegrationStatus';
import i18n from 'DesignData/reducers/I18n';
import previewerWindow from 'DesignData/reducers/PreviewerWindow';
import statusBar from 'DesignData/reducers/StatusBar';
import languages from 'DesignData/reducers/Languages';
import compiledHubL from 'DesignData/reducers/CompiledHubL';
import designComponents from 'DesignData/reducers/designComponents';
import codeEditor from 'DesignData/reducers/codeEditor';
import userSettings from 'DesignData/reducers/userSettings';
import session from 'DesignData/reducers/session';
import rawAssetBuffers from 'DesignData/reducers/RawAssetBuffers';
import rawAssetEditorOptions from 'DesignData/reducers/RawAssetEditorOptions';
import rawAssetRevisions from 'DesignData/reducers/RawAssetRevisions';
import ecosystem from 'DesignData/reducers/Ecosystem';
import graphqlFiles from 'DesignData/reducers/GraphqlFiles';
export default combineReducers({
  app,
  auth,
  fonts,
  notifications,
  routing: routerReducer,
  cosIndexConnections,
  customWidgetBuffers,
  customWidgets,
  globalGroups,
  globalWidgets,
  structuralWidgets,
  revisions,
  tabs,
  templateBuffers,
  templateRevisions,
  unifiedLayouts,
  siteSettings,
  stylesheets,
  javascripts,
  graphqlFiles,
  blogs,
  domains,
  layoutEditorOptions,
  // TODO: Deprecated, use sharedDragDropContext instead.
  layoutDragDropContext,
  sharedDragDropContext,
  previewOptions,
  layoutEditorSession,
  layoutGrouping,
  portalCopy,
  finder,
  codemirrorOptions,
  codemirrorSession,
  layoutRevisions,
  customWidgetEditorOptions,
  resources,
  customWidgetRevisions,
  flash,
  onboarding,
  editorErrors,
  hublValidator,
  hublDocs,
  salesforceIntegrationStatus,
  i18n,
  previewerWindow,
  statusBar,
  languages,
  compiledHubL,
  codeEditor,
  designComponents,
  userSettings,
  session,
  rawAssetBuffers,
  rawAssetEditorOptions,
  rawAssetRevisions,
  ecosystem
});